module.exports = __webpack_public_path__ + "img/documentsinactive.759bd5e1.svg";